;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import PropTypes from 'prop-types';

import { SubNavItems } from './SubNavItems';

import styles from './SubNav.module.scss';

/**
 * Renders a subnav dropdown panel (left column with items/group triggers).
 */
const SubNav = ({ item }) => {
    return (
        <nav className={styles.subNav}>
            <div className={styles.subNavLeft}>
                <SubNavItems
                    items={item.itemsCollection.items}
                    headingLink={item.link}
                    headingTitle={item.subMenuTitle}
                />
            </div>
        </nav>
    );
};

SubNav.propTypes = {
    item: PropTypes.shape({}).isRequired,
};

export { SubNav };
